import { Dialog, Tooltip } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai"; // Import Close icon from react-icons
import { FaInfoCircle } from "react-icons/fa"; // Import Info icon
import { baseurl } from "../../config/url";
import { calculateVisibilityCharges, calculateHireVisibilityCharges } from "../../utils/calculateVisibilityCharges";
import { displayRazorpay } from "../../utils/rozorpay";
import { showErrorToast, showSuccessToast } from "../../utils/toaster";
import AddProductInvoice from "./AddproductInVoice";
import BillComponent from "./BillComponent";
import OtherPaymentOptions from "./otherPayment";

const AddProductDialog = ({
  open,
  setDialogOpen,
  visibilityLevel,
  setVisibilityLevel,
  handlePopupSubmit,
  setPowerPackVisibility,
  powerPackVisibility,
  ammount,
  maxquantity,
  saleMode,
  products,
  priority,
  handlevideoPrivorityCheckboxChange,
  categoryName, 
  subcategoryName, 

}) => {
  console.log("🚀 AddProductDialog Props Debugging:");
console.log("🔹 Category Name:", categoryName);
console.log("🔹 Subcategory Name:", subcategoryName);
console.log("🔹 Amount:", ammount);
console.log("🔹 Max Quantity:", maxquantity);



  // const visibilityPrices =
  //   ammount && maxquantity
  //     ? {
  //         "1X": calculateVisibilityCharges(+ammount, +maxquantity, "1X"),
  //         "2X": calculateVisibilityCharges(+ammount, +maxquantity, "2X"),
  //         "3X": calculateVisibilityCharges(+ammount, +maxquantity, "3X"),
  //         "4X": calculateVisibilityCharges(+ammount, +maxquantity, "4X"),
  //       }
  //     : {};
// Detect Hire Mode
const isHireMode = saleMode === "Sale By Seller" && products[0]?.saleProduct === "Hire";

// For Hire Mode → Only use Hire Charge (no maxquantity multiplication)
const monthlyHireValue = isHireMode
  ? Number(products[0]?.hireChargeAmount || 0) * Number(maxquantity || 1)
  : 0;


// Visibility Prices Calculation
const visibilityPrices =
  (isHireMode && monthlyHireValue)
    ? {
        "1X": calculateHireVisibilityCharges(monthlyHireValue, "1X"),
        "2X": calculateHireVisibilityCharges(monthlyHireValue, "2X"),
        "3X": calculateHireVisibilityCharges(monthlyHireValue, "3X"),
        "4X": calculateHireVisibilityCharges(monthlyHireValue, "4X"),
      }
    : (ammount && maxquantity)
    ? {
        "1X": calculateVisibilityCharges(+ammount, +maxquantity, "1X"),
        "2X": calculateVisibilityCharges(+ammount, +maxquantity, "2X"),
        "3X": calculateVisibilityCharges(+ammount, +maxquantity, "3X"),
        "4X": calculateVisibilityCharges(+ammount, +maxquantity, "4X"),
      }
    : {};

// 🔍 Console Debugging Block (Highly Recommended)
console.group("🔍 Visibility Charges Debugging");
console.log("👉 Sale Mode:", saleMode);
console.log("👉 Is Hire Mode:", isHireMode);

if (isHireMode) {
  console.log("👉 Monthly Hire Value (Hire Charge Only):", monthlyHireValue);
  console.log("👉 Visibility Prices for Hire:");
  console.table(visibilityPrices);
} else {
  const saleProductValue = (+ammount || 0) * (+maxquantity || 0);
  console.log("👉 Product Value for Sale (Amount × Max Quantity):", saleProductValue);
  console.log("👉 Visibility Prices for Sale:");
  console.table(visibilityPrices);
}
console.groupEnd();




  const visibilityPrice = visibilityPrices[visibilityLevel] || 0; // default 0 if visibility price not availible 
  const powerPackPrice = powerPackVisibility ? 25000 : 0;
  const totalPrice = visibilityPrice ? visibilityPrice : 0 + powerPackPrice;

  // deposit amount calculation start
  let depositAmount = saleMode === "Sale By OGCS" ? ammount * maxquantity : 0;
  const depositTax = Math.round(depositAmount * 0.12);
  depositAmount = depositTax;
  // deposit amount calculation end

  const handleVisibilityChange = (event) => {
    setVisibilityLevel(event.target.value);
  };
  const [showOtherPayment, setShowOtherPayment] = useState(false);
  const [productId, setProductId] = useState(null);
  const handlePowerPackChange = (event) => {
    setPowerPackVisibility(event.target.checked);
  };

  const handleSaveProduct = async () => {
    try {
      await handlePopupSubmit(null, null); // Save the product without payment
      showSuccessToast("Product saved successfully!");
    } catch (error) {
      showErrorToast("Failed to save the product. Please try again.");
    }
  };

  const handleOtherPaymentOptions = () => {
    showSuccessToast("Redirecting to other payment options...");
    // Implement logic for alternative payment options
  };

  const storeSellerVisibilityPayment = async (productId, data) => {
    const sellerId = localStorage.getItem("sellerId");
    if (!sellerId) {
      showErrorToast("Seller ID not found. Please log in again.");
      return;
    }
  
    const GST_RATE = 18; // GST percentage
    const powerPackGST = (powerPackPrice * GST_RATE) / 100; // GST for Power Pack Price
    const visibilityGST = (visibilityPrice * GST_RATE) / 100; // GST for Visibility Amount (if applicable)
  
    const totalGST =
      saleMode === "Sale By OGCS" ? powerPackGST : visibilityGST + powerPackGST; // GST inclusion logic
  
    const finalTotalAmount =
      saleMode === "Sale By OGCS"
        ? depositAmount + powerPackPrice + powerPackGST // Deposit + PowerPack Price + GST
        : visibilityPrice + powerPackPrice + totalGST; // Visibility Price + PowerPack Price + Total GST
  
    const paymentData = {
      sellerId,
      products: [
        {
          productId: productId,
          visibilityLevel: visibilityLevel || "1X",
          visibilityAmount: visibilityPrice,
          powerPack: powerPackPrice ? true : false,
          powerPackAmount: powerPackPrice,
          gst: totalGST, // GST amount
          totalProductAmount:
            saleMode === "Sale By OGCS"
              ? depositAmount + powerPackPrice + powerPackGST
              : visibilityPrice + powerPackPrice + totalGST, // Product total amount
        },
      ],
      totalAmount: finalTotalAmount, // Final total amount
      orderCreationId: data?.orderCreationId,
      razorpayOrderId: data?.razorpayOrderId,
      razorpayPaymentId: data?.razorpayPaymentId,
      razorpaySignature: data?.razorpaySignature,
    };
  
    try {
      const response = await axios.post(
        `${baseurl}/api/payment/seller-visibility-payment-store-todb`,
        paymentData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      showSuccessToast("Payment stored successfully!");
    } catch (error) {
      showErrorToast(
        `Failed to store payment details. Please try again. ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };
  

  let handlefunctionafterpayment = (data) => {
    handlePopupSubmit(data, storeSellerVisibilityPayment);
  };
  let handleSubmit = (totalAmount) => {
    // displayRazorpay is for open rozorpay modal, after success handlefunctionafterpayment will call for store product and payment  
    displayRazorpay(totalAmount, handlefunctionafterpayment);
  };
console.log("🛠️ Products Check:", products);

  return (
    <Dialog
      open={open}
      onClose={() => setDialogOpen(false)}
      maxWidth="lg"
      fullWidth
    >
      <div className="relative pb-3 rounded-lg shadow-lg overflow-auto box-border flex flex-col lg:flex-row">
        {/* Close Button */}
        <button
          onClick={() => setDialogOpen(false)}
          className="absolute top-4 right-4 p-2 text-gray-600 hover:text-gray-800 transition-all duration-200"
        >
          <AiOutlineClose size={28} />
        </button>

        {/* Left Side: Visibility and Power Pack  */}
        <div className="space-y-6 px-8 box-border w-full lg:w-1/2">
          {saleMode === "Sale By Seller" && (
            <div>
              <h3 className="text-lg font-medium mb-2 text-gray-700 flex items-center space-x-2">
                {/* <span>Visibility Selection</span> */}
                <span>{isHireMode ? "Hire Visibility Selection" : "Visibility Selection"}</span>

                <Tooltip
                  title={
                    <span>
                      <strong>Visibility Levels</strong>: Select a visibility
                      level for your product. Higher visibility levels ensure
                      your product is shown more prominently to customers.
                    </span>
                  }
                  arrow
                  placement="top"
                >
                  <span>
                    <FaInfoCircle
                      style={{ fontSize: 20, cursor: "pointer", color: "gray" }}
                    />
                  </span>
                </Tooltip>
              </h3>
              <div className="space-y-2">
                {Object.entries(visibilityPrices).map(([key, price]) => (
                  <label
                    key={key}
                    className="flex items-center space-x-3 cursor-pointer"
                  >
                    <input
                      type="radio"
                      value={key}
                      checked={visibilityLevel === key}
                      onChange={handleVisibilityChange}
                      className="w-5 h-4 text-blue-600 cursor-pointer"
                    />
                    <span className="mb-1 text-base text-gray-600">{`${key} - ₹${price}`}</span>
                  </label>
                ))}
              </div>
            </div>
          )}

          {/* New Section for Video Priority */}
          <div className="space-y-3 mt-6">
            <h3 className="text-lg font-medium text-gray-700 flex items-center space-x-2">
              <span>Video Priority</span>
              <Tooltip
                title={
                  <span>
                    <strong>Video Priority Levels</strong>: Choose the priority
                    for your video. 1X priority will give your video a standard
                    view, while 3X priority will make it more prominent and show
                    it to more users. If you opt for a higher priority, our team
                    will reach out to you for further setup.
                  </span>
                }
                arrow
                placement="top"
              >
                <span>
                  <FaInfoCircle
                    style={{ fontSize: 20, cursor: "pointer", color: "gray" }}
                  />
                </span>
              </Tooltip>
            </h3>
            <div className="space-y-2">
              <label className="flex items-center space-x-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={priority.is1XPriority}
                  onChange={() =>
                    handlevideoPrivorityCheckboxChange("is1XPriority")
                  }
                  className="w-5 h-5 text-blue-600 cursor-pointer"
                />
                <span className="text-base text-gray-600">
                  1X Video Priority
                </span>
              </label>

              <label className="flex items-center space-x-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={priority.is3XPriority}
                  onChange={() =>
                    handlevideoPrivorityCheckboxChange("is3XPriority")
                  }
                  className="w-5 h-5 text-blue-600 cursor-pointer"
                />
                <span className="text-base text-gray-600">
                  3X Video Priority
                </span>
              </label>
            </div>
            <div className="text-sm text-gray-600">
              <p>
                For any inquiries or further details regarding video priority,
                our team will connect with you directly.
              </p>
            </div>
          </div>

          <div className="space-y-3">
            <label className="flex items-center space-x-3 cursor-pointer">
              <input
                type="checkbox"
                checked={powerPackVisibility}
                onChange={handlePowerPackChange}
                className="cursor-pointer w-5 h-5 text-blue-600"
              />
              <span className="mb-1 text-lg text-gray-600">
                Power Pack (+ ₹25000)
              </span>
              <Tooltip
                title={
                  <span>
                    <strong>PowerPack Visibility</strong>: If you select this,
                    your product will be directly displayed on the homepage.
                    When a user clicks on your product from the homepage, it
                    will bypass the product detail page and go directly to the{" "}
                    <strong>Add to Cart</strong>.
                  </span>
                }
                arrow
                placement="top"
              >
                <span>
                  <FaInfoCircle
                    style={{ fontSize: 20, cursor: "pointer", color: "gray" }}
                  />
                </span>
              </Tooltip>
            </label>
          </div>
                
          <BillComponent
            handleSubmit={handleSubmit}
            visibilityPrice={visibilityPrice}
            powerPackPrice={powerPackPrice}
            totalPrice={totalPrice}
            ammount={ammount}
            maxquantity={maxquantity}
            saleMode={saleMode}
            categoryName={categoryName}  
            subcategoryName={subcategoryName} 
  saleProduct={products[0]?.saleProduct}
  hireChargeAmount={products[0]?.hireChargeAmount}
  hireDuration={products[0]?.hireDuration}
    selectedHireType={products[0]?.selectedHireType} // 👈 Add this

          />
          <div className="flex justify-between mt-6">
            <button
              className="px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition duration-200 shadow-md"
              onClick={handleSaveProduct}
            >
              Save Product
            </button>
            <button onClick={() => setShowOtherPayment(true)}>
              Choose Other Payment Options
            </button>
            {showOtherPayment && (
              <Dialog
                open={showOtherPayment}
                onClose={() => setShowOtherPayment(false)}
              >
                <OtherPaymentOptions
                  productId={productId} // Pass the product ID
                  onClose={() => setShowOtherPayment(false)}
                />
              </Dialog>
            )}
          </div>
        </div>

        {/* Right Side: Billing Information */}
        <div className="box-border w-full lg:w-1/2 mt-8 lg:mt-0">
          <AddProductInvoice
            visibilityPrice={visibilityPrice}
            powerPackPrice={powerPackPrice}
            ammount={ammount}
            maxquantity={maxquantity}
            saleMode={saleMode}
            products={products}
            categoryName={categoryName} 
            subcategoryName={subcategoryName}  
          />
        </div>
      </div>
    </Dialog>
  );
};

export default AddProductDialog;







// import { Dialog, Tooltip } from "@mui/material";
// import axios from "axios";
// import React, { useState } from "react";
// import { AiOutlineClose } from "react-icons/ai"; // Import Close icon from react-icons
// import { FaInfoCircle } from "react-icons/fa"; // Import Info icon
// import { baseurl } from "../../config/url";
// import { calculateVisibilityCharges } from "../../utils/calculateVisibilityCharges";
// import { displayRazorpay } from "../../utils/rozorpay";
// import { showErrorToast, showSuccessToast } from "../../utils/toaster";
// import AddProductInvoice from "./AddproductInVoice";
// import BillComponent from "./BillComponent";
// import OtherPaymentOptions from "./otherPayment";

// const AddProductDialog = ({
//   open,
//   setDialogOpen,
//   visibilityLevel,
//   setVisibilityLevel,
//   handlePopupSubmit,
//   setPowerPackVisibility,
//   powerPackVisibility,
//   ammount,
//   maxquantity,
//   saleMode,
//   products,
//   priority,
//   handlevideoPrivorityCheckboxChange,
//   selectedCategory,
//   selectedSubcategory,
  
// }) => {
//   const visibilityPrices =
//     ammount && maxquantity
//       ? {
//           "1X": calculateVisibilityCharges(+ammount, +maxquantity, "1X"),
//           "2X": calculateVisibilityCharges(+ammount, +maxquantity, "2X"),
//           "3X": calculateVisibilityCharges(+ammount, +maxquantity, "3X"),
//           "4X": calculateVisibilityCharges(+ammount, +maxquantity, "4X"),
//         }
//       : {};

//   const visibilityPrice = visibilityPrices[visibilityLevel] || 0; // default 0 if visibility price not availible 
//   const powerPackPrice = powerPackVisibility ? 25000 : 0;
//   const totalPrice = visibilityPrice ? visibilityPrice : 0 + powerPackPrice;

//   // deposit amount calculation start
//   let depositAmount = saleMode === "Sale By OGCS" ? ammount * maxquantity : 0;
//   const depositTax = Math.round(depositAmount * 0.12);
//   depositAmount = depositTax;
//   // deposit amount calculation end

//   const handleVisibilityChange = (event) => {
//     setVisibilityLevel(event.target.value);
//   };
//   const [showOtherPayment, setShowOtherPayment] = useState(false);
//   const [productId, setProductId] = useState(null);
//   const handlePowerPackChange = (event) => {
//     setPowerPackVisibility(event.target.checked);
//   };

//   const handleSaveProduct = async () => {
//     try {
//       await handlePopupSubmit(null, null); // Save the product without payment
//       showSuccessToast("Product saved successfully!");
//     } catch (error) {
//       showErrorToast("Failed to save the product. Please try again.");
//     }
//   };

//   const handleOtherPaymentOptions = () => {
//     showSuccessToast("Redirecting to other payment options...");
//     // Implement logic for alternative payment options
//   };

//   const storeSellerVisibilityPayment = async (productId, data) => {
//     const sellerId = localStorage.getItem("sellerId");
//     if (!sellerId) {
//       showErrorToast("Seller ID not found. Please log in again.");
//       return;
//     }
  
//     const GST_RATE = 18; // GST percentage
//     const powerPackGST = (powerPackPrice * GST_RATE) / 100; // GST for Power Pack Price
//     const visibilityGST = (visibilityPrice * GST_RATE) / 100; // GST for Visibility Amount (if applicable)
  
//     const totalGST =
//       saleMode === "Sale By OGCS" ? powerPackGST : visibilityGST + powerPackGST; // GST inclusion logic
  
//     const finalTotalAmount =
//       saleMode === "Sale By OGCS"
//         ? depositAmount + powerPackPrice + powerPackGST // Deposit + PowerPack Price + GST
//         : visibilityPrice + powerPackPrice + totalGST; // Visibility Price + PowerPack Price + Total GST
  
//     const paymentData = {
//       sellerId,
//       products: [
//         {
//           productId: productId,
//           visibilityLevel: visibilityLevel || "1X",
//           visibilityAmount: visibilityPrice,
//           powerPack: powerPackPrice ? true : false,
//           powerPackAmount: powerPackPrice,
//           gst: totalGST, // GST amount
//           totalProductAmount:
//             saleMode === "Sale By OGCS"
//               ? depositAmount + powerPackPrice + powerPackGST
//               : visibilityPrice + powerPackPrice + totalGST, // Product total
//         },
//       ],
//       totalAmount: finalTotalAmount, // Final total amount
//       orderCreationId: data?.orderCreationId,
//       razorpayOrderId: data?.razorpayOrderId,
//       razorpayPaymentId: data?.razorpayPaymentId,
//       razorpaySignature: data?.razorpaySignature,
//     };
  
//     try {
//       const response = await axios.post(
//         `${baseurl}/api/payment/seller-visibility-payment-store-todb`,
//         paymentData,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
  
//       showSuccessToast("Payment stored successfully!");
//     } catch (error) {
//       showErrorToast(
//         `Failed to store payment details. Please try again. ${
//           error.response?.data?.message || error.message
//         }`
//       );
//     }
//   };
  

//   let handlefunctionafterpayment = (data) => {
//     handlePopupSubmit(data, storeSellerVisibilityPayment);
//   };
//   let handleSubmit = (totalAmount) => {
//     // displayRazorpay is for open rozorpay modal, after success handlefunctionafterpayment will call for store product and payment  
//     displayRazorpay(totalAmount, handlefunctionafterpayment);
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={() => setDialogOpen(false)}
//       maxWidth="lg"
//       fullWidth
//     >
//       <div className="relative pb-3 rounded-lg shadow-lg overflow-auto box-border flex flex-col lg:flex-row">
//         {/* Close Button */}
//         <button
//           onClick={() => setDialogOpen(false)}
//           className="absolute top-4 right-4 p-2 text-gray-600 hover:text-gray-800 transition-all duration-200"
//         >
//           <AiOutlineClose size={28} />
//         </button>

//         {/* Left Side: Visibility and Power Pack */}
//         <div className="space-y-6 px-8 box-border w-full lg:w-1/2">
//           {saleMode === "Sale By Seller" && (
//             <div>
//               <h3 className="text-lg font-medium mb-2 text-gray-700 flex items-center space-x-2">
//                 <span>Visibility Selection</span>
//                 <Tooltip
//                   title={
//                     <span>
//                       <strong>Visibility Levels</strong>: Select a visibility
//                       level for your product. Higher visibility levels ensure
//                       your product is shown more prominently to customers.
//                     </span>
//                   }
//                   arrow
//                   placement="top"
//                 >
//                   <span>
//                     <FaInfoCircle
//                       style={{ fontSize: 20, cursor: "pointer", color: "gray" }}
//                     />
//                   </span>
//                 </Tooltip>
//               </h3>
//               <div className="space-y-2">
//                 {Object.entries(visibilityPrices).map(([key, price]) => (
//                   <label
//                     key={key}
//                     className="flex items-center space-x-3 cursor-pointer"
//                   >
//                     <input
//                       type="radio"
//                       value={key}
//                       checked={visibilityLevel === key}
//                       onChange={handleVisibilityChange}
//                       className="w-5 h-4 text-blue-600 cursor-pointer"
//                     />
//                     <span className="mb-1 text-base text-gray-600">{`${key} - ₹${price}`}</span>
//                   </label>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* New Section for Video Priority */}
//           <div className="space-y-3 mt-6">
//             <h3 className="text-lg font-medium text-gray-700 flex items-center space-x-2">
//               <span>Video Priority</span>
//               <Tooltip
//                 title={
//                   <span>
//                     <strong>Video Priority Levels</strong>: Choose the priority
//                     for your video. 1X priority will give your video a standard
//                     view, while 3X priority will make it more prominent and show
//                     it to more users. If you opt for a higher priority, our team
//                     will reach out to you for further setup.
//                   </span>
//                 }
//                 arrow
//                 placement="top"
//               >
//                 <span>
//                   <FaInfoCircle
//                     style={{ fontSize: 20, cursor: "pointer", color: "gray" }}
//                   />
//                 </span>
//               </Tooltip>
//             </h3>
//             <div className="space-y-2">
//               <label className="flex items-center space-x-3 cursor-pointer">
//                 <input
//                   type="checkbox"
//                   checked={priority.is1XPriority}
//                   onChange={() =>
//                     handlevideoPrivorityCheckboxChange("is1XPriority")
//                   }
//                   className="w-5 h-5 text-blue-600 cursor-pointer"
//                 />
//                 <span className="text-base text-gray-600">
//                   1X Video Priority
//                 </span>
//               </label>

//               <label className="flex items-center space-x-3 cursor-pointer">
//                 <input
//                   type="checkbox"
//                   checked={priority.is3XPriority}
//                   onChange={() =>
//                     handlevideoPrivorityCheckboxChange("is3XPriority")
//                   }
//                   className="w-5 h-5 text-blue-600 cursor-pointer"
//                 />
//                 <span className="text-base text-gray-600">
//                   3X Video Priority
//                 </span>
//               </label>
//             </div>
//             <div className="text-sm text-gray-600">
//               <p>
//                 For any inquiries or further details regarding video priority,
//                 our team will connect with you directly.
//               </p>
//             </div>
//           </div>

//           <div className="space-y-3">
//             <label className="flex items-center space-x-3 cursor-pointer">
//               <input
//                 type="checkbox"
//                 checked={powerPackVisibility}
//                 onChange={handlePowerPackChange}
//                 className="cursor-pointer w-5 h-5 text-blue-600"
//               />
//               <span className="mb-1 text-lg text-gray-600">
//                 Power Pack (+ ₹25000)
//               </span>
//               <Tooltip
//                 title={
//                   <span>
//                     <strong>PowerPack Visibility</strong>: If you select this,
//                     your product will be directly displayed on the homepage.
//                     When a user clicks on your product from the homepage, it
//                     will bypass the product detail page and go directly to the{" "}
//                     <strong>Add to Cart</strong>.
//                   </span>
//                 }
//                 arrow
//                 placement="top"
//               >
//                 <span>
//                   <FaInfoCircle
//                     style={{ fontSize: 20, cursor: "pointer", color: "gray" }}
//                   />
//                 </span>
//               </Tooltip>
//             </label>
//           </div>

//           <BillComponent
//             handleSubmit={handleSubmit}
//             visibilityPrice={visibilityPrice}
//             powerPackPrice={powerPackPrice}
//             totalPrice={totalPrice}
//             ammount={ammount}
//             maxquantity={maxquantity}
//             saleMode={saleMode}
//             category={selectedCategory}
//             subcategory={selectedSubcategory}
//           />
//           <div className="flex justify-between mt-6">
//             <button
//               className="px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition duration-200 shadow-md"
//               onClick={handleSaveProduct}
//             >
//               Save Product
//             </button>
//             <button onClick={() => setShowOtherPayment(true)}>
//               Choose Other Payment Options
//             </button>
//             {showOtherPayment && (
//               <Dialog
//                 open={showOtherPayment}
//                 onClose={() => setShowOtherPayment(false)}
//               >
//                 <OtherPaymentOptions
//                   productId={productId} // Pass the product ID
//                   onClose={() => setShowOtherPayment(false)}
//                 />
//               </Dialog>
//             )}
//           </div>
//         </div>

//         {/* Right Side: Billing Information */}
//         <div className="box-border w-full lg:w-1/2 mt-8 lg:mt-0">
//           <AddProductInvoice
//             visibilityPrice={visibilityPrice}
//             powerPackPrice={powerPackPrice}
//             ammount={ammount}
//             maxquantity={maxquantity}
//             saleMode={saleMode}
//             products={products}
//           />
//         </div>
//       </div>
//     </Dialog>
//   );
// };

// export default AddProductDialog;
